 
  (function () {
    function hasSwiper() {
      return typeof Swiper !== 'undefined';
    }

    function initHeroSwipers(context) {
      if (!hasSwiper()) return;

      var scope = context || document;
      var containers = scope.querySelectorAll('.kg-hero-swiper');
      if (!containers.length) return;

      containers.forEach(function (container) {
        if (container.__kgInitialized) return;
        container.__kgInitialized = true;

        var paginationEl = container.querySelector('.swiper-pagination');
        var nextEl = container.querySelector('.swiper-button-next');
        var prevEl = container.querySelector('.swiper-button-prev');

        var autoplayEnabled = container.dataset.autoplay !== 'false' && container.dataset.autoplay !== '';
        var autoplayDelay = parseInt(container.dataset.autoplayDelay, 10) || 5000;

        new Swiper(container, {
          loop: true,
          speed: 750,
          autoplay: autoplayEnabled
            ? {
                delay: autoplayDelay,
                disableOnInteraction: false,
                pauseOnMouseEnter: false,
              }
            : false,
          effect: 'fade',
          fadeEffect: { crossFade: true },
          pagination: paginationEl
            ? { el: paginationEl, clickable: true }
            : undefined,
          navigation:
            nextEl && prevEl
              ? { nextEl: nextEl, prevEl: prevEl }
              : undefined,
        });
      });
    }

    function initTestiSwipers(context) {
      if (!hasSwiper()) return;

      var scope = context || document;
      var containers = scope.querySelectorAll('.kg-testi__swiper');
      if (!containers.length) return;

      containers.forEach(function (container) {
        if (container.__kgInitialized) return;
        container.__kgInitialized = true;

        var paginationEl = container.querySelector('.kg-testi__pagination');

        new Swiper(container, {
          slidesPerView: 3,
          spaceBetween: 24,
          loop: true,
          centeredSlides: false,
          autoplay: {
            delay: 4000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          },
          pagination: paginationEl
            ? {
                el: paginationEl,
                clickable: true,
              }
            : undefined,
          breakpoints: {
            0: { slidesPerView: 1, spaceBetween: 16 },
            640: { slidesPerView: 2, spaceBetween: 20 },
            1024: { slidesPerView: 3, spaceBetween: 24 },
          },
        });
      });
    }

    function initProductsSwipers(context) {
      if (!hasSwiper()) return;

      var scope = context || document;
      var containers = scope.querySelectorAll('.kg-products__swiper');
      if (!containers.length) return;

      containers.forEach(function (container) {
        if (container.closest('.kg-featured-collection')) return;
        if (container.__kgInitialized) return;
        container.__kgInitialized = true;

        var paginationEl = container.querySelector('.kg-products__pagination');
        var prevEl = container.querySelector('.kg-products__prev');
        var nextEl = container.querySelector('.kg-products__next');

        new Swiper(container, {
          slidesPerView: 4,
          spaceBetween: 24,
          loop: true,
          pagination: paginationEl
            ? {
                el: paginationEl,
                clickable: true,
              }
            : undefined,
          navigation:
            prevEl && nextEl
              ? {
                  prevEl: prevEl,
                  nextEl: nextEl,
                }
              : undefined,
          breakpoints: {
            0: { slidesPerView: 1, spaceBetween: 16 },
            480: { slidesPerView: 2, spaceBetween: 16 },
            768: { slidesPerView: 3, spaceBetween: 20 },
            1024: { slidesPerView: 4, spaceBetween: 24 },
          },
        });
      });
    }

    function initAll(context) {
      initHeroSwipers(context);
      initTestiSwipers(context);
      initProductsSwipers(context);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      var sectionId = event.detail && event.detail.sectionId;
      var sectionEl = sectionId
        ? document.getElementById('shopify-section-' + sectionId)
        : null;
      initAll(sectionEl || document);
    });
  })();

  // ── Mobile sidebar ──
//   (function () {
//     var hamburger = document.getElementById('kg-hamburger');
//     var sidebar = document.getElementById('kg-sidebar');
//     var overlay = document.getElementById('kg-sidebar-overlay');
//     var closeBtn = document.getElementById('kg-sidebar-close');

//     function openSidebar() {
//       sidebar.classList.add('kg-is-active');
//       overlay.classList.add('kg-is-active');
//       hamburger.classList.add('kg-is-active');
//       document.body.classList.add('kg-sidebar-open');
//       hamburger.setAttribute('aria-expanded', 'true');
//       sidebar.setAttribute('aria-hidden', 'false');
//     }

//     function closeSidebar() {
//       sidebar.classList.remove('kg-is-active');
//       overlay.classList.remove('kg-is-active');
//       hamburger.classList.remove('kg-is-active');
//       document.body.classList.remove('kg-sidebar-open');
//       hamburger.setAttribute('aria-expanded', 'false');
//       sidebar.setAttribute('aria-hidden', 'true');
//     }

//     hamburger.addEventListener('click', function () {
//       sidebar.classList.contains('kg-is-active') ? closeSidebar() : openSidebar();
//     });

//     closeBtn.addEventListener('click', closeSidebar);
//     overlay.addEventListener('click', closeSidebar);
//     document.addEventListener('keydown', function (e) {
//       if (e.key === 'Escape') closeSidebar();
//     });
//   })();
 